/* Custom tags follow Shopify's native privacy choices. No consent is recorded here. */
(() => {
  let googleLoaded = false, analyticsStarted = false, adsStarted = false, facebookStarted = false;
  const GA = 'G-S0CKRG45ZB', ADS = 'AW-18240585492';
  function script(src) { const el = document.createElement('script'); el.async = true; el.src = src; document.head.appendChild(el); }
  function sync() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    const analytics = privacy.analyticsProcessingAllowed();
    const marketing = privacy.marketingAllowed();
    window['ga-disable-' + GA] = !analytics;
    if (analytics || marketing || googleLoaded) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
      const state = {analytics_storage: analytics ? 'granted' : 'denied', ad_storage: marketing ? 'granted' : 'denied', ad_user_data: marketing ? 'granted' : 'denied', ad_personalization: marketing ? 'granted' : 'denied'};
      window.gtag('consent', googleLoaded ? 'update' : 'default', state);
      if (!googleLoaded) {
        googleLoaded = true;
        window.gtag('js', new Date());
        script('https://www.googletagmanager.com/gtag/js?id=' + (analytics ? GA : ADS));
      }
      if (analytics && !analyticsStarted) { analyticsStarted = true; window.gtag('config', GA); }
      if (marketing && !adsStarted) { adsStarted = true; window.gtag('config', ADS); }
    }
    if (marketing && !facebookStarted) {
      facebookStarted = true;
      if (!window.fbq) {
        const q = function () { q.callMethod ? q.callMethod.apply(q, arguments) : q.queue.push(arguments); };
        q.queue = []; q.loaded = true; q.version = '2.0'; q.push = q;
        window.fbq = q; window._fbq = q;
        script('https://connect.facebook.net/en_US/fbevents.js');
      }
      window.fbq('consent', 'grant');
      window.fbq('init', '1456191802977642');
      window.fbq('track', 'PageView');
    } else if (facebookStarted) { window.fbq('consent', marketing ? 'grant' : 'revoke'); }
  }
  document.addEventListener('visitorConsentCollected', sync);
  function init() {
    if (window.Shopify?.customerPrivacy) { sync(); return; }
    if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) sync(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
